﻿import AddressUnitDesignator from "../enums/AddressUnitDesignator";

export function unitDesignatorToString(designator: AddressUnitDesignator): string {
	switch (designator) {
		case AddressUnitDesignator.None:
			return "#";
		case AddressUnitDesignator.Apartment:
			return "APT";
		case AddressUnitDesignator.Basement:
			return "BSMT";
		case AddressUnitDesignator.Building:
			return "BLDG";
		case AddressUnitDesignator.Department:
			return "DEPT";
		case AddressUnitDesignator.Floor:
			return "FL";
		case AddressUnitDesignator.Front:
			return "FRNT";
		case AddressUnitDesignator.Hanger:
			return "HNGR";
		case AddressUnitDesignator.Key:
			return "KEY";
		case AddressUnitDesignator.Lobby:
			return "LBBY";
		case AddressUnitDesignator.Lot:
			return "LOT";
		case AddressUnitDesignator.Lower:
			return "LOWR";
		case AddressUnitDesignator.Office:
			return "OFC";
		case AddressUnitDesignator.Penthouse:
			return "PH";
		case AddressUnitDesignator.Pier:
			return "PIER";
		case AddressUnitDesignator.Rear:
			return "REAR";
		case AddressUnitDesignator.Room:
			return "RM";
		case AddressUnitDesignator.Side:
			return "SIDE";
		case AddressUnitDesignator.Slip:
			return "SLIP";
		case AddressUnitDesignator.Space:
			return "SPC";
		case AddressUnitDesignator.Stop:
			return "STOP";
		case AddressUnitDesignator.Suite:
			return "STE";
		case AddressUnitDesignator.Trailer:
			return "TRLR";
		case AddressUnitDesignator.Unit:
			return "UNIT";
		case AddressUnitDesignator.Upper:
			return "UPPR";
		default:
			return "";
	}
}
